export default __webpack_public_path__ + "static/media/SentRequest.584e328c.svg";